module.exports = __webpack_public_path__ + "static/img/作品72.39a4963.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品72.png
// module id = OunH
// module chunks = 1